export var CommandCode;
(function (CommandCode) {
    CommandCode[CommandCode["Undefined"] = 0] = "Undefined";
    CommandCode[CommandCode["Register"] = 1] = "Register";
    CommandCode[CommandCode["Login"] = 2] = "Login";
    CommandCode[CommandCode["ChoosePlayerName"] = 3] = "ChoosePlayerName";
    CommandCode[CommandCode["DisconnectPlayer"] = 4] = "DisconnectPlayer";
    CommandCode[CommandCode["RefreshCache"] = 6] = "RefreshCache";
    CommandCode[CommandCode["Ping"] = 7] = "Ping";
    CommandCode[CommandCode["FacebookConnectInfo"] = 20] = "FacebookConnectInfo";
    CommandCode[CommandCode["FacebookConnect"] = 21] = "FacebookConnect";
    CommandCode[CommandCode["FacebookFriendInfo"] = 22] = "FacebookFriendInfo";
    CommandCode[CommandCode["GoogleConnectInfo"] = 23] = "GoogleConnectInfo";
    CommandCode[CommandCode["GoogleConnect"] = 24] = "GoogleConnect";
    CommandCode[CommandCode["AmazonConnectInfo"] = 26] = "AmazonConnectInfo";
    CommandCode[CommandCode["AmazonConnect"] = 27] = "AmazonConnect";
    CommandCode[CommandCode["DeviceConnect"] = 28] = "DeviceConnect";
    CommandCode[CommandCode["EmailConnect"] = 29] = "EmailConnect";
    CommandCode[CommandCode["EmailConnectInfo"] = 30] = "EmailConnectInfo";
    CommandCode[CommandCode["AppleConnectInfo"] = 31] = "AppleConnectInfo";
    CommandCode[CommandCode["AppleConnect"] = 32] = "AppleConnect";
    CommandCode[CommandCode["ChoosePlayerProfilePicture"] = 40] = "ChoosePlayerProfilePicture";
    CommandCode[CommandCode["PlayerChangeSettings"] = 41] = "PlayerChangeSettings";
    CommandCode[CommandCode["PlayerPreferencesStorage"] = 42] = "PlayerPreferencesStorage";
    CommandCode[CommandCode["PlayerInfo"] = 50] = "PlayerInfo";
    CommandCode[CommandCode["FarmInfo"] = 51] = "FarmInfo";
    CommandCode[CommandCode["InventoryInfo"] = 52] = "InventoryInfo";
    CommandCode[CommandCode["ProductionInfo"] = 53] = "ProductionInfo";
    CommandCode[CommandCode["QuestInfo"] = 54] = "QuestInfo";
    CommandCode[CommandCode["EventInfo"] = 55] = "EventInfo";
    CommandCode[CommandCode["ContractInfo"] = 56] = "ContractInfo";
    CommandCode[CommandCode["PackagePurchaseInfo"] = 58] = "PackagePurchaseInfo";
    CommandCode[CommandCode["OutskirtsInfo"] = 59] = "OutskirtsInfo";
    CommandCode[CommandCode["PendingInventoryInfo"] = 60] = "PendingInventoryInfo";
    CommandCode[CommandCode["PlayerProfileInfo"] = 61] = "PlayerProfileInfo";
    CommandCode[CommandCode["VisitOtherFarmInfo"] = 62] = "VisitOtherFarmInfo";
    CommandCode[CommandCode["CafeRecipeInfo"] = 63] = "CafeRecipeInfo";
    CommandCode[CommandCode["LimitedActionInfo"] = 65] = "LimitedActionInfo";
    CommandCode[CommandCode["FacebookPointsInfo"] = 66] = "FacebookPointsInfo";
    CommandCode[CommandCode["ShiftLevelInfo"] = 67] = "ShiftLevelInfo";
    CommandCode[CommandCode["AchievementInfo"] = 68] = "AchievementInfo";
    CommandCode[CommandCode["PaymentEntryInfo"] = 69] = "PaymentEntryInfo";
    CommandCode[CommandCode["PlayerSettingsInfo"] = 70] = "PlayerSettingsInfo";
    CommandCode[CommandCode["SubscriptionChangeInfo"] = 71] = "SubscriptionChangeInfo";
    CommandCode[CommandCode["SubscriptionInfo"] = 72] = "SubscriptionInfo";
    CommandCode[CommandCode["ProductionEffectItemInfo"] = 73] = "ProductionEffectItemInfo";
    CommandCode[CommandCode["LoginNotificationServer"] = 80] = "LoginNotificationServer";
    CommandCode[CommandCode["ReloadScheduledEventsNotification"] = 81] = "ReloadScheduledEventsNotification";
    CommandCode[CommandCode["UpcomingMaintenance"] = 82] = "UpcomingMaintenance";
    CommandCode[CommandCode["ExpandFarmGold"] = 100] = "ExpandFarmGold";
    CommandCode[CommandCode["ExpandFarmResource"] = 101] = "ExpandFarmResource";
    CommandCode[CommandCode["StartConstructGold"] = 102] = "StartConstructGold";
    CommandCode[CommandCode["StartConstructResource"] = 103] = "StartConstructResource";
    CommandCode[CommandCode["SkipConstruct"] = 104] = "SkipConstruct";
    CommandCode[CommandCode["FinishConstruct"] = 105] = "FinishConstruct";
    CommandCode[CommandCode["StartUpgradeGold"] = 106] = "StartUpgradeGold";
    CommandCode[CommandCode["StartUpgradeResource"] = 107] = "StartUpgradeResource";
    CommandCode[CommandCode["SkipUpgrade"] = 108] = "SkipUpgrade";
    CommandCode[CommandCode["FinishUpgrade"] = 109] = "FinishUpgrade";
    CommandCode[CommandCode["Demolish"] = 110] = "Demolish";
    CommandCode[CommandCode["MoveBuilding"] = 111] = "MoveBuilding";
    CommandCode[CommandCode["StoreBuilding"] = 112] = "StoreBuilding";
    CommandCode[CommandCode["UnstoreBuilding"] = 113] = "UnstoreBuilding";
    CommandCode[CommandCode["BuyFarmImprovement"] = 114] = "BuyFarmImprovement";
    CommandCode[CommandCode["PvpMapAttack"] = 130] = "PvpMapAttack";
    CommandCode[CommandCode["PvpMapInfo"] = 131] = "PvpMapInfo";
    CommandCode[CommandCode["PvpMapJoin"] = 132] = "PvpMapJoin";
    CommandCode[CommandCode["PvpMapNotification"] = 133] = "PvpMapNotification";
    CommandCode[CommandCode["PvpMapReinforce"] = 134] = "PvpMapReinforce";
    CommandCode[CommandCode["PvpLeagueInfo"] = 135] = "PvpLeagueInfo";
    CommandCode[CommandCode["PvpLeagueRanking"] = 136] = "PvpLeagueRanking";
    CommandCode[CommandCode["CreateCoop"] = 150] = "CreateCoop";
    CommandCode[CommandCode["UpdateCoop"] = 151] = "UpdateCoop";
    CommandCode[CommandCode["JoinCoop"] = 152] = "JoinCoop";
    CommandCode[CommandCode["LeaveCoop"] = 153] = "LeaveCoop";
    CommandCode[CommandCode["KickCoopMember"] = 154] = "KickCoopMember";
    CommandCode[CommandCode["AssignCoopMemberRole"] = 155] = "AssignCoopMemberRole";
    CommandCode[CommandCode["SendCoopPoints"] = 156] = "SendCoopPoints";
    CommandCode[CommandCode["CollectCoopPoints"] = 157] = "CollectCoopPoints";
    CommandCode[CommandCode["UpdateCoopProject"] = 158] = "UpdateCoopProject";
    CommandCode[CommandCode["SearchCoop"] = 159] = "SearchCoop";
    CommandCode[CommandCode["JoinableCoopList"] = 160] = "JoinableCoopList";
    CommandCode[CommandCode["StartCoopProject"] = 161] = "StartCoopProject";
    CommandCode[CommandCode["StopCoopProject"] = 162] = "StopCoopProject";
    CommandCode[CommandCode["DonateToCoop"] = 163] = "DonateToCoop";
    CommandCode[CommandCode["BuyCoopImprovement"] = 164] = "BuyCoopImprovement";
    CommandCode[CommandCode["BuyCoopBuff"] = 165] = "BuyCoopBuff";
    CommandCode[CommandCode["CoopInvitePlayer"] = 195] = "CoopInvitePlayer";
    CommandCode[CommandCode["CoopCancelInvite"] = 196] = "CoopCancelInvite";
    CommandCode[CommandCode["CoopInviteInfo"] = 197] = "CoopInviteInfo";
    CommandCode[CommandCode["PlayerInviteInfo"] = 198] = "PlayerInviteInfo";
    CommandCode[CommandCode["PlayerCancelInvite"] = 199] = "PlayerCancelInvite";
    CommandCode[CommandCode["CoopInfo"] = 201] = "CoopInfo";
    CommandCode[CommandCode["CoopPointsInfo"] = 202] = "CoopPointsInfo";
    CommandCode[CommandCode["CoopMemberInfo"] = 203] = "CoopMemberInfo";
    CommandCode[CommandCode["KickedCoopMemberInfo"] = 204] = "KickedCoopMemberInfo";
    CommandCode[CommandCode["CoopProjectTypeInfo"] = 205] = "CoopProjectTypeInfo";
    CommandCode[CommandCode["CoopProjectInfo"] = 206] = "CoopProjectInfo";
    CommandCode[CommandCode["CoopInventoryInfo"] = 207] = "CoopInventoryInfo";
    CommandCode[CommandCode["CoopImprovementInfo"] = 208] = "CoopImprovementInfo";
    CommandCode[CommandCode["CoopBuffInfo"] = 209] = "CoopBuffInfo";
    CommandCode[CommandCode["CoopMessageInfo"] = 211] = "CoopMessageInfo";
    CommandCode[CommandCode["InboxInfo"] = 230] = "InboxInfo";
    CommandCode[CommandCode["ReadInboxItem"] = 231] = "ReadInboxItem";
    CommandCode[CommandCode["CollectInBoxItemAttachments"] = 232] = "CollectInBoxItemAttachments";
    CommandCode[CommandCode["DeleteInboxItem"] = 233] = "DeleteInboxItem";
    CommandCode[CommandCode["InboxUpdateNotification"] = 234] = "InboxUpdateNotification";
    CommandCode[CommandCode["StartProduce"] = 250] = "StartProduce";
    CommandCode[CommandCode["BoostProduce"] = 251] = "BoostProduce";
    CommandCode[CommandCode["SkipProduce"] = 252] = "SkipProduce";
    CommandCode[CommandCode["CollectProducts"] = 253] = "CollectProducts";
    CommandCode[CommandCode["SellProducts"] = 254] = "SellProducts";
    CommandCode[CommandCode["BuyProducts"] = 255] = "BuyProducts";
    CommandCode[CommandCode["BuyProductsGold"] = 256] = "BuyProductsGold";
    CommandCode[CommandCode["DonateResource"] = 257] = "DonateResource";
    CommandCode[CommandCode["CancelProduction"] = 258] = "CancelProduction";
    CommandCode[CommandCode["FulfillContract"] = 275] = "FulfillContract";
    CommandCode[CommandCode["DismissContract"] = 276] = "DismissContract";
    CommandCode[CommandCode["SkipContract"] = 277] = "SkipContract";
    CommandCode[CommandCode["QuestStart"] = 285] = "QuestStart";
    CommandCode[CommandCode["QuestUpdate"] = 286] = "QuestUpdate";
    CommandCode[CommandCode["QuestFinish"] = 287] = "QuestFinish";
    CommandCode[CommandCode["SkipQuestTask"] = 288] = "SkipQuestTask";
    CommandCode[CommandCode["CompleteQuestState"] = 289] = "CompleteQuestState";
    CommandCode[CommandCode["PaymentPackageList"] = 300] = "PaymentPackageList";
    CommandCode[CommandCode["VerifyPaymentReceipt"] = 301] = "VerifyPaymentReceipt";
    CommandCode[CommandCode["OpenTransactionList"] = 302] = "OpenTransactionList";
    CommandCode[CommandCode["FinishTransaction"] = 303] = "FinishTransaction";
    CommandCode[CommandCode["WebShopCatalog"] = 304] = "WebShopCatalog";
    CommandCode[CommandCode["WebShopCheckout"] = 305] = "WebShopCheckout";
    CommandCode[CommandCode["UpdatePaymentEntry"] = 306] = "UpdatePaymentEntry";
    CommandCode[CommandCode["MapPlayerSubscription"] = 307] = "MapPlayerSubscription";
    CommandCode[CommandCode["VerifySubscriptionReceipt"] = 308] = "VerifySubscriptionReceipt";
    CommandCode[CommandCode["BuyPackage"] = 310] = "BuyPackage";
    CommandCode[CommandCode["ConsumePackage"] = 311] = "ConsumePackage";
    CommandCode[CommandCode["ConsumePendingInventory"] = 312] = "ConsumePendingInventory";
    CommandCode[CommandCode["BuyDogPackage"] = 313] = "BuyDogPackage";
    CommandCode[CommandCode["ConsumeDogPackageBonus"] = 314] = "ConsumeDogPackageBonus";
    CommandCode[CommandCode["ConsumeUnlockedPackage"] = 315] = "ConsumeUnlockedPackage";
    CommandCode[CommandCode["UnlockedPackageInfo"] = 316] = "UnlockedPackageInfo";
    CommandCode[CommandCode["UnlockLoginPackage"] = 317] = "UnlockLoginPackage";
    CommandCode[CommandCode["OfferCharacteristicsList"] = 320] = "OfferCharacteristicsList";
    CommandCode[CommandCode["BalloonInfo"] = 330] = "BalloonInfo";
    CommandCode[CommandCode["ConsumeBalloon"] = 331] = "ConsumeBalloon";
    CommandCode[CommandCode["PopBalloon"] = 332] = "PopBalloon";
    CommandCode[CommandCode["GrantReward"] = 340] = "GrantReward";
    CommandCode[CommandCode["GrantCoopReward"] = 341] = "GrantCoopReward";
    CommandCode[CommandCode["SendAndCollectFacebookPoints"] = 342] = "SendAndCollectFacebookPoints";
    CommandCode[CommandCode["CollectCollectablePointReward"] = 343] = "CollectCollectablePointReward";
    CommandCode[CommandCode["CollectedPointRewardInfo"] = 344] = "CollectedPointRewardInfo";
    CommandCode[CommandCode["UpgradeOutskirt"] = 350] = "UpgradeOutskirt";
    CommandCode[CommandCode["BuyLibraryImprovement"] = 351] = "BuyLibraryImprovement";
    CommandCode[CommandCode["BuyMarketImprovement"] = 352] = "BuyMarketImprovement";
    CommandCode[CommandCode["CollectWater"] = 353] = "CollectWater";
    CommandCode[CommandCode["ProduceAndCollectOutskirt"] = 355] = "ProduceAndCollectOutskirt";
    CommandCode[CommandCode["StartFarmMachine"] = 358] = "StartFarmMachine";
    CommandCode[CommandCode["ExchangeFreeTreatPoints"] = 359] = "ExchangeFreeTreatPoints";
    CommandCode[CommandCode["CatchFish"] = 360] = "CatchFish";
    CommandCode[CommandCode["SellFish"] = 361] = "SellFish";
    CommandCode[CommandCode["BuyPierImprovement"] = 363] = "BuyPierImprovement";
    CommandCode[CommandCode["CookFish"] = 364] = "CookFish";
    CommandCode[CommandCode["SkipCooking"] = 365] = "SkipCooking";
    CommandCode[CommandCode["CollectFishFilet"] = 366] = "CollectFishFilet";
    CommandCode[CommandCode["CookingPansInfo"] = 367] = "CookingPansInfo";
    CommandCode[CommandCode["PlayerLeagueInfo"] = 411] = "PlayerLeagueInfo";
    CommandCode[CommandCode["PlayerLeagueRanking"] = 412] = "PlayerLeagueRanking";
    CommandCode[CommandCode["CoopLeagueInfo"] = 413] = "CoopLeagueInfo";
    CommandCode[CommandCode["CoopLeagueRanking"] = 414] = "CoopLeagueRanking";
    CommandCode[CommandCode["CollectLeagueInfo"] = 415] = "CollectLeagueInfo";
    CommandCode[CommandCode["CollectLeagueRanking"] = 416] = "CollectLeagueRanking";
    CommandCode[CommandCode["ThemedEventStart"] = 430] = "ThemedEventStart";
    CommandCode[CommandCode["ThemedEventFinish"] = 431] = "ThemedEventFinish";
    CommandCode[CommandCode["UpdateLeagueEvent"] = 432] = "UpdateLeagueEvent";
    CommandCode[CommandCode["UpdateCoopLeagueEvent"] = 433] = "UpdateCoopLeagueEvent";
    CommandCode[CommandCode["TemporaryFarmStart"] = 434] = "TemporaryFarmStart";
    CommandCode[CommandCode["UpdateCollectLeagueEvent"] = 435] = "UpdateCollectLeagueEvent";
    CommandCode[CommandCode["UpdatePurchasePointEvent"] = 436] = "UpdatePurchasePointEvent";
    CommandCode[CommandCode["PurchasePointInfo"] = 437] = "PurchasePointInfo";
    CommandCode[CommandCode["TraderInfo"] = 438] = "TraderInfo";
    CommandCode[CommandCode["UpdateTraderEvent"] = 439] = "UpdateTraderEvent";
    CommandCode[CommandCode["StartQuestTreeEvent"] = 440] = "StartQuestTreeEvent";
    CommandCode[CommandCode["CollectLoginReward"] = 441] = "CollectLoginReward";
    CommandCode[CommandCode["FortuneTellerInfo"] = 442] = "FortuneTellerInfo";
    CommandCode[CommandCode["LoginEventInfo"] = 443] = "LoginEventInfo";
    CommandCode[CommandCode["UpdateLongTermPointEvent"] = 444] = "UpdateLongTermPointEvent";
    CommandCode[CommandCode["LongTermPointEventInfo"] = 445] = "LongTermPointEventInfo";
    CommandCode[CommandCode["LongTermPointEventRankInfo"] = 446] = "LongTermPointEventRankInfo";
    CommandCode[CommandCode["UpdatePvpLeagueEvent"] = 447] = "UpdatePvpLeagueEvent";
    CommandCode[CommandCode["LoginChatServer"] = 451] = "LoginChatServer";
    CommandCode[CommandCode["GetChatRoom"] = 452] = "GetChatRoom";
    CommandCode[CommandCode["PostInChatRoom"] = 453] = "PostInChatRoom";
    CommandCode[CommandCode["NewMessageInChatRoomNotice"] = 454] = "NewMessageInChatRoomNotice";
    CommandCode[CommandCode["ServerLogin"] = 490] = "ServerLogin";
    CommandCode[CommandCode["ServerExecuteCommand"] = 491] = "ServerExecuteCommand";
    CommandCode[CommandCode["ServerDispatchResponse"] = 492] = "ServerDispatchResponse";
    CommandCode[CommandCode["AddResourceCheat"] = 500] = "AddResourceCheat";
    CommandCode[CommandCode["AddBuildingCheat"] = 501] = "AddBuildingCheat";
    CommandCode[CommandCode["AddXpCheat"] = 502] = "AddXpCheat";
    CommandCode[CommandCode["AddOutskirtXpCheat"] = 503] = "AddOutskirtXpCheat";
    CommandCode[CommandCode["AddCoopXpCheat"] = 504] = "AddCoopXpCheat";
    CommandCode[CommandCode["UpdateQuestTasksCheat"] = 506] = "UpdateQuestTasksCheat";
    CommandCode[CommandCode["NextOffersCheat"] = 507] = "NextOffersCheat";
    CommandCode[CommandCode["SubscriptionCheat"] = 508] = "SubscriptionCheat";
    CommandCode[CommandCode["UpdateShiftLevelCheat"] = 509] = "UpdateShiftLevelCheat";
    CommandCode[CommandCode["SubscriptionLevelCheat"] = 510] = "SubscriptionLevelCheat";
    CommandCode[CommandCode["AddCoopProjectCompletionsCheat"] = 512] = "AddCoopProjectCompletionsCheat";
    CommandCode[CommandCode["AssignCoopMemberRoleCheat"] = 513] = "AssignCoopMemberRoleCheat";
    CommandCode[CommandCode["CollectProductsCheat"] = 514] = "CollectProductsCheat";
    CommandCode[CommandCode["UpdatePlayerLeagueCheat"] = 515] = "UpdatePlayerLeagueCheat";
    CommandCode[CommandCode["UpdateCoopLeagueCheat"] = 516] = "UpdateCoopLeagueCheat";
    CommandCode[CommandCode["AddAdventurerXpCheat"] = 517] = "AddAdventurerXpCheat";
    CommandCode[CommandCode["LastLoginCheat"] = 518] = "LastLoginCheat";
    CommandCode[CommandCode["ResetBalloonOfferCheat"] = 519] = "ResetBalloonOfferCheat";
    CommandCode[CommandCode["UpdateCollectLeagueCheat"] = 520] = "UpdateCollectLeagueCheat";
    CommandCode[CommandCode["WebPaymentCheat"] = 521] = "WebPaymentCheat";
    CommandCode[CommandCode["AddCoopResourceCheat"] = 522] = "AddCoopResourceCheat";
    CommandCode[CommandCode["AdjustCoopProjectTimeCheat"] = 523] = "AdjustCoopProjectTimeCheat";
    CommandCode[CommandCode["ResetLimitedActionsCheat"] = 524] = "ResetLimitedActionsCheat";
    CommandCode[CommandCode["UpdatePurchasePointCheat"] = 525] = "UpdatePurchasePointCheat";
    CommandCode[CommandCode["AdjustUnlockPackageTimeCheat"] = 526] = "AdjustUnlockPackageTimeCheat";
    CommandCode[CommandCode["AdjustCookingTimeCheat"] = 527] = "AdjustCookingTimeCheat";
    CommandCode[CommandCode["UpdateLoginEventCheat"] = 528] = "UpdateLoginEventCheat";
    CommandCode[CommandCode["UpdateCoopMemberJoinTimeCheat"] = 529] = "UpdateCoopMemberJoinTimeCheat";
    CommandCode[CommandCode["UpdateLongTermPointEventCheat"] = 530] = "UpdateLongTermPointEventCheat";
    CommandCode[CommandCode["UpdateEventScheduleCheat"] = 531] = "UpdateEventScheduleCheat";
    CommandCode[CommandCode["ClientIpCheat"] = 532] = "ClientIpCheat";
    CommandCode[CommandCode["AddPvpUnitsCheat"] = 533] = "AddPvpUnitsCheat";
    CommandCode[CommandCode["AddPvpEnergyCheat"] = 534] = "AddPvpEnergyCheat";
    CommandCode[CommandCode["UpdatePvpEventPointsCheat"] = 535] = "UpdatePvpEventPointsCheat";
    CommandCode[CommandCode["AddBuildingSlotCheat"] = 536] = "AddBuildingSlotCheat";
})(CommandCode || (CommandCode = {}));
export var StatusCode;
(function (StatusCode) {
    StatusCode[StatusCode["Undefined"] = 0] = "Undefined";
    StatusCode[StatusCode["OK"] = 200] = "OK";
    StatusCode[StatusCode["DEVICE_INVALID"] = 100] = "DEVICE_INVALID";
    StatusCode[StatusCode["DEVICE_ALREADY_REGISTERED"] = 101] = "DEVICE_ALREADY_REGISTERED";
    StatusCode[StatusCode["ACCESS_TOKEN_ERROR"] = 102] = "ACCESS_TOKEN_ERROR";
    StatusCode[StatusCode["DISCONNECT_BY_LOGIN"] = 103] = "DISCONNECT_BY_LOGIN";
    StatusCode[StatusCode["BANNED"] = 104] = "BANNED";
    StatusCode[StatusCode["INVALID_PLATFORM_TYPE"] = 105] = "INVALID_PLATFORM_TYPE";
    StatusCode[StatusCode["INVALID_DEVICE_TYPE"] = 106] = "INVALID_DEVICE_TYPE";
    StatusCode[StatusCode["INVALID_EMAIL"] = 107] = "INVALID_EMAIL";
    StatusCode[StatusCode["INVALID_PASSWORD"] = 108] = "INVALID_PASSWORD";
    StatusCode[StatusCode["INVALID_PASSWORD_LENGTH"] = 109] = "INVALID_PASSWORD_LENGTH";
    StatusCode[StatusCode["INVALID_PASSWORD_FORMAT"] = 110] = "INVALID_PASSWORD_FORMAT";
    StatusCode[StatusCode["INVALID_EMAIL_FORMAT"] = 111] = "INVALID_EMAIL_FORMAT";
    StatusCode[StatusCode["PROCESSING_PENDING"] = 300] = "PROCESSING_PENDING";
    StatusCode[StatusCode["ACCESS_DENIED"] = 403] = "ACCESS_DENIED";
    StatusCode[StatusCode["INVALID_ACTION"] = 405] = "INVALID_ACTION";
    StatusCode[StatusCode["NO_PERMISSION"] = 406] = "NO_PERMISSION";
    StatusCode[StatusCode["INVALID_BUSINESS_TERMS"] = 407] = "INVALID_BUSINESS_TERMS";
    StatusCode[StatusCode["INVALID_IDS"] = 410] = "INVALID_IDS";
    StatusCode[StatusCode["INVALID_COOP_ID"] = 411] = "INVALID_COOP_ID";
    StatusCode[StatusCode["INVALID_PLAYER_ID"] = 412] = "INVALID_PLAYER_ID";
    StatusCode[StatusCode["INVALID_FARM_ID"] = 413] = "INVALID_FARM_ID";
    StatusCode[StatusCode["INVALID_EXPANSION_ID"] = 414] = "INVALID_EXPANSION_ID";
    StatusCode[StatusCode["INVALID_BUILDING_ID"] = 415] = "INVALID_BUILDING_ID";
    StatusCode[StatusCode["INVALID_ITEM_ID"] = 416] = "INVALID_ITEM_ID";
    StatusCode[StatusCode["INVALID_PACKAGE_ID"] = 417] = "INVALID_PACKAGE_ID";
    StatusCode[StatusCode["INVALID_TRANSFER_ID"] = 418] = "INVALID_TRANSFER_ID";
    StatusCode[StatusCode["INVALID_QUEST_ID"] = 419] = "INVALID_QUEST_ID";
    StatusCode[StatusCode["INVALID_RECIPE_ID"] = 420] = "INVALID_RECIPE_ID";
    StatusCode[StatusCode["INVALID_PRODUCTION_ID"] = 421] = "INVALID_PRODUCTION_ID";
    StatusCode[StatusCode["INVALID_CONTRACT_ID"] = 422] = "INVALID_CONTRACT_ID";
    StatusCode[StatusCode["INVALID_RESEARCH_ID"] = 423] = "INVALID_RESEARCH_ID";
    StatusCode[StatusCode["INVALID_IMPROVEMENT_ID"] = 424] = "INVALID_IMPROVEMENT_ID";
    StatusCode[StatusCode["INVALID_OUTSKIRT_ID"] = 425] = "INVALID_OUTSKIRT_ID";
    StatusCode[StatusCode["INVALID_EVENT_ID"] = 426] = "INVALID_EVENT_ID";
    StatusCode[StatusCode["INVALID_PROJECT_ID"] = 427] = "INVALID_PROJECT_ID";
    StatusCode[StatusCode["INVALID_BALLOON_ID"] = 428] = "INVALID_BALLOON_ID";
    StatusCode[StatusCode["INVALID_COOKING_PAN_ID"] = 429] = "INVALID_COOKING_PAN_ID";
    StatusCode[StatusCode["INVALID_PROJECT_STATE"] = 430] = "INVALID_PROJECT_STATE";
    StatusCode[StatusCode["INVALID_BUILDING_STATE"] = 431] = "INVALID_BUILDING_STATE";
    StatusCode[StatusCode["INVALID_PRODUCTION_STATE"] = 432] = "INVALID_PRODUCTION_STATE";
    StatusCode[StatusCode["INVALID_QUEST_STATE"] = 433] = "INVALID_QUEST_STATE";
    StatusCode[StatusCode["INVALID_EVENT_STATE"] = 434] = "INVALID_EVENT_STATE";
    StatusCode[StatusCode["INVALID_CONTRACT_STATE"] = 435] = "INVALID_CONTRACT_STATE";
    StatusCode[StatusCode["INVALID_SHIP_STATE"] = 436] = "INVALID_SHIP_STATE";
    StatusCode[StatusCode["INVALID_MISSION_STATE"] = 437] = "INVALID_MISSION_STATE";
    StatusCode[StatusCode["INVALID_DATA"] = 440] = "INVALID_DATA";
    StatusCode[StatusCode["INVALID_AMOUNT"] = 441] = "INVALID_AMOUNT";
    StatusCode[StatusCode["INVALID_POSITION"] = 442] = "INVALID_POSITION";
    StatusCode[StatusCode["INVALID_ROTATION"] = 443] = "INVALID_ROTATION";
    StatusCode[StatusCode["INVALID_LEVEL"] = 444] = "INVALID_LEVEL";
    StatusCode[StatusCode["INVALID_COOP_LEVEL"] = 445] = "INVALID_COOP_LEVEL";
    StatusCode[StatusCode["INVALID_DESCRIPTION"] = 446] = "INVALID_DESCRIPTION";
    StatusCode[StatusCode["INVALID_INTERNAL_NOTICE"] = 447] = "INVALID_INTERNAL_NOTICE";
    StatusCode[StatusCode["INVALID_REWARD_ID"] = 448] = "INVALID_REWARD_ID";
    StatusCode[StatusCode["NOT_ENOUGH_RESOURCES"] = 450] = "NOT_ENOUGH_RESOURCES";
    StatusCode[StatusCode["NOT_ENOUGH_WORKERS"] = 451] = "NOT_ENOUGH_WORKERS";
    StatusCode[StatusCode["NO_FREE_BUILD_SLOT"] = 452] = "NO_FREE_BUILD_SLOT";
    StatusCode[StatusCode["LIMIT_REACHED"] = 453] = "LIMIT_REACHED";
    StatusCode[StatusCode["STORAGE_LIMIT_REACHED"] = 454] = "STORAGE_LIMIT_REACHED";
    StatusCode[StatusCode["BUILDING_LIMIT_REACHED"] = 455] = "BUILDING_LIMIT_REACHED";
    StatusCode[StatusCode["CHAT_USER_NOT_EXISTING"] = 456] = "CHAT_USER_NOT_EXISTING";
    StatusCode[StatusCode["PACKAGE_PURCHASE_MAX_REACHED"] = 457] = "PACKAGE_PURCHASE_MAX_REACHED";
    StatusCode[StatusCode["PAN_IN_USE"] = 458] = "PAN_IN_USE";
    StatusCode[StatusCode["PAN_IS_LOCKED"] = 459] = "PAN_IS_LOCKED";
    StatusCode[StatusCode["NAME_INVALID"] = 460] = "NAME_INVALID";
    StatusCode[StatusCode["NAME_IN_USE"] = 461] = "NAME_IN_USE";
    StatusCode[StatusCode["BAD_WORD"] = 462] = "BAD_WORD";
    StatusCode[StatusCode["BAD_WORD_IN_SECOND_FIELD"] = 463] = "BAD_WORD_IN_SECOND_FIELD";
    StatusCode[StatusCode["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    StatusCode[StatusCode["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    StatusCode[StatusCode["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    StatusCode[StatusCode["INVALID_VERSION"] = 505] = "INVALID_VERSION";
})(StatusCode || (StatusCode = {}));
export var ItemType;
(function (ItemType) {
    ItemType[ItemType["CURRENCY_TYPE"] = 0] = "CURRENCY_TYPE";
    ItemType[ItemType["GOOD_TYPE"] = 1] = "GOOD_TYPE";
    ItemType[ItemType["BUILDING_TYPE"] = 2] = "BUILDING_TYPE";
    ItemType[ItemType["PACKAGE_TYPE"] = 3] = "PACKAGE_TYPE";
    ItemType[ItemType["PROFILE_PICTURE_TYPE"] = 4] = "PROFILE_PICTURE_TYPE";
    ItemType[ItemType["PVP_UNIT_TYPE"] = 5] = "PVP_UNIT_TYPE";
})(ItemType || (ItemType = {}));
export var BuildingStateType;
(function (BuildingStateType) {
    BuildingStateType[BuildingStateType["IDLE"] = 0] = "IDLE";
    BuildingStateType[BuildingStateType["CONSTRUCTING"] = 1] = "CONSTRUCTING";
    BuildingStateType[BuildingStateType["UPGRADING"] = 2] = "UPGRADING";
    BuildingStateType[BuildingStateType["DEMOLISHING"] = 3] = "DEMOLISHING";
})(BuildingStateType || (BuildingStateType = {}));
export var BuffHierarchyType;
(function (BuffHierarchyType) {
    BuffHierarchyType[BuffHierarchyType["ALLIANCE"] = 0] = "ALLIANCE";
    BuffHierarchyType[BuffHierarchyType["PLAYER"] = 1] = "PLAYER";
    BuffHierarchyType[BuffHierarchyType["FARM"] = 2] = "FARM";
    BuffHierarchyType[BuffHierarchyType["BUILDING_CATEGORY"] = 3] = "BUILDING_CATEGORY";
    BuffHierarchyType[BuffHierarchyType["BUILDING_GROUP"] = 4] = "BUILDING_GROUP";
    BuffHierarchyType[BuffHierarchyType["BUILDING"] = 5] = "BUILDING";
})(BuffHierarchyType || (BuffHierarchyType = {}));
export var BuffContextType;
(function (BuffContextType) {
    BuffContextType[BuffContextType["ANY_CONTEXT"] = 0] = "ANY_CONTEXT";
    BuffContextType[BuffContextType["PRODUCTION"] = 1] = "PRODUCTION";
    BuffContextType[BuffContextType["CONSTRUCTION"] = 2] = "CONSTRUCTION";
    BuffContextType[BuffContextType["EXPANSION"] = 3] = "EXPANSION";
    BuffContextType[BuffContextType["TRADE"] = 4] = "TRADE";
    BuffContextType[BuffContextType["MISSION"] = 5] = "MISSION";
    BuffContextType[BuffContextType["EVENT"] = 6] = "EVENT";
    BuffContextType[BuffContextType["CONTRACT"] = 7] = "CONTRACT";
    BuffContextType[BuffContextType["CAFE"] = 8] = "CAFE";
    BuffContextType[BuffContextType["PROJECT"] = 9] = "PROJECT";
    BuffContextType[BuffContextType["FISH"] = 10] = "FISH";
    BuffContextType[BuffContextType["OFFER"] = 11] = "OFFER";
})(BuffContextType || (BuffContextType = {}));
export var BuffTargetType;
(function (BuffTargetType) {
    BuffTargetType[BuffTargetType["ANY_TARGET"] = 0] = "ANY_TARGET";
    BuffTargetType[BuffTargetType["TIME"] = 1] = "TIME";
    BuffTargetType[BuffTargetType["COST"] = 2] = "COST";
    BuffTargetType[BuffTargetType["PRODUCT"] = 3] = "PRODUCT";
    BuffTargetType[BuffTargetType["REVENUE"] = 4] = "REVENUE";
    BuffTargetType[BuffTargetType["XP"] = 5] = "XP";
    BuffTargetType[BuffTargetType["FAME"] = 6] = "FAME";
    BuffTargetType[BuffTargetType["MARKET_XP"] = 7] = "MARKET_XP";
    BuffTargetType[BuffTargetType["ADVENTURER_XP"] = 8] = "ADVENTURER_XP";
    BuffTargetType[BuffTargetType["HAPPINESS"] = 9] = "HAPPINESS";
    BuffTargetType[BuffTargetType["SATISFACTION"] = 10] = "SATISFACTION";
    BuffTargetType[BuffTargetType["POINTS"] = 11] = "POINTS";
    BuffTargetType[BuffTargetType["FISHING_XP"] = 12] = "FISHING_XP";
    BuffTargetType[BuffTargetType["HIT_AREA"] = 13] = "HIT_AREA";
})(BuffTargetType || (BuffTargetType = {}));
export var QuestStateType;
(function (QuestStateType) {
    QuestStateType[QuestStateType["OPEN"] = 0] = "OPEN";
    QuestStateType[QuestStateType["PROGRESS"] = 1] = "PROGRESS";
    QuestStateType[QuestStateType["COMPLETE"] = 2] = "COMPLETE";
    QuestStateType[QuestStateType["REWARDED"] = 3] = "REWARDED";
    QuestStateType[QuestStateType["REMOVED"] = 4] = "REMOVED";
})(QuestStateType || (QuestStateType = {}));
export var CoopJoinPolicyType;
(function (CoopJoinPolicyType) {
    CoopJoinPolicyType[CoopJoinPolicyType["JOINABLE"] = 0] = "JOINABLE";
    CoopJoinPolicyType[CoopJoinPolicyType["BY_INVITATION"] = 1] = "BY_INVITATION";
    CoopJoinPolicyType[CoopJoinPolicyType["CLOSED"] = 2] = "CLOSED";
})(CoopJoinPolicyType || (CoopJoinPolicyType = {}));
export var CoopMemberRoleType;
(function (CoopMemberRoleType) {
    CoopMemberRoleType[CoopMemberRoleType["LEADER"] = 0] = "LEADER";
    CoopMemberRoleType[CoopMemberRoleType["DEPUTY"] = 1] = "DEPUTY";
    CoopMemberRoleType[CoopMemberRoleType["MEMBER"] = 2] = "MEMBER";
    CoopMemberRoleType[CoopMemberRoleType["CANDIDATE"] = 3] = "CANDIDATE";
})(CoopMemberRoleType || (CoopMemberRoleType = {}));
export var LimitedActionType;
(function (LimitedActionType) {
    LimitedActionType[LimitedActionType["DOGHOUSE"] = 0] = "DOGHOUSE";
    LimitedActionType[LimitedActionType["DOGHOUSE_AD"] = 1] = "DOGHOUSE_AD";
    LimitedActionType[LimitedActionType["WATER_TOWER"] = 2] = "WATER_TOWER";
    LimitedActionType[LimitedActionType["CONTRACT_SKIP_AD"] = 3] = "CONTRACT_SKIP_AD";
    LimitedActionType[LimitedActionType["CONTRACT_AD"] = 4] = "CONTRACT_AD";
    LimitedActionType[LimitedActionType["CATCH"] = 5] = "CATCH";
    LimitedActionType[LimitedActionType["FACEBOOK_POINTS"] = 6] = "FACEBOOK_POINTS";
    LimitedActionType[LimitedActionType["LOYALTY_POINTS"] = 7] = "LOYALTY_POINTS";
})(LimitedActionType || (LimitedActionType = {}));
export var LimitedActionResetType;
(function (LimitedActionResetType) {
    LimitedActionResetType[LimitedActionResetType["DAILY_BASE"] = 0] = "DAILY_BASE";
    LimitedActionResetType[LimitedActionResetType["ON_ACTION"] = 1] = "ON_ACTION";
    LimitedActionResetType[LimitedActionResetType["NO_RESET"] = 2] = "NO_RESET";
})(LimitedActionResetType || (LimitedActionResetType = {}));
export var PendingInventoryType;
(function (PendingInventoryType) {
    PendingInventoryType[PendingInventoryType["ANY_SOURCE"] = 0] = "ANY_SOURCE";
    PendingInventoryType[PendingInventoryType["SYSTEM"] = 1] = "SYSTEM";
    PendingInventoryType[PendingInventoryType["PLAYER_LEAGUE_RANKING"] = 10] = "PLAYER_LEAGUE_RANKING";
    PendingInventoryType[PendingInventoryType["PLAYER_LEAGUE_POINTS_1"] = 11] = "PLAYER_LEAGUE_POINTS_1";
    PendingInventoryType[PendingInventoryType["PLAYER_LEAGUE_POINTS_2"] = 12] = "PLAYER_LEAGUE_POINTS_2";
    PendingInventoryType[PendingInventoryType["PLAYER_LEAGUE_POINTS_3"] = 13] = "PLAYER_LEAGUE_POINTS_3";
    PendingInventoryType[PendingInventoryType["PLAYER_LEAGUE_POINTS_4"] = 14] = "PLAYER_LEAGUE_POINTS_4";
    PendingInventoryType[PendingInventoryType["PLAYER_LEAGUE_POINTS_5"] = 15] = "PLAYER_LEAGUE_POINTS_5";
    PendingInventoryType[PendingInventoryType["PLAYER_LEAGUE_POINTS_6"] = 16] = "PLAYER_LEAGUE_POINTS_6";
    PendingInventoryType[PendingInventoryType["COOP_LEAGUE_RANKING"] = 20] = "COOP_LEAGUE_RANKING";
    PendingInventoryType[PendingInventoryType["COOP_LEAGUE_POINTS_1"] = 21] = "COOP_LEAGUE_POINTS_1";
    PendingInventoryType[PendingInventoryType["COOP_LEAGUE_POINTS_2"] = 22] = "COOP_LEAGUE_POINTS_2";
    PendingInventoryType[PendingInventoryType["COOP_LEAGUE_POINTS_3"] = 23] = "COOP_LEAGUE_POINTS_3";
    PendingInventoryType[PendingInventoryType["COOP_LEAGUE_POINTS_4"] = 24] = "COOP_LEAGUE_POINTS_4";
    PendingInventoryType[PendingInventoryType["COOP_LEAGUE_POINTS_5"] = 25] = "COOP_LEAGUE_POINTS_5";
    PendingInventoryType[PendingInventoryType["COOP_LEAGUE_POINTS_6"] = 26] = "COOP_LEAGUE_POINTS_6";
    PendingInventoryType[PendingInventoryType["WELCOME_BACK_PACKAGE"] = 30] = "WELCOME_BACK_PACKAGE";
    PendingInventoryType[PendingInventoryType["SONY_GIFT"] = 31] = "SONY_GIFT";
    PendingInventoryType[PendingInventoryType["CAFE_CELEBRATION_GIFT"] = 32] = "CAFE_CELEBRATION_GIFT";
    PendingInventoryType[PendingInventoryType["SKY_LAUNCH_GIFT"] = 33] = "SKY_LAUNCH_GIFT";
    PendingInventoryType[PendingInventoryType["FACEBOOK_INVITEE"] = 34] = "FACEBOOK_INVITEE";
    PendingInventoryType[PendingInventoryType["FACEBOOK_INVITER"] = 35] = "FACEBOOK_INVITER";
    PendingInventoryType[PendingInventoryType["BIRTHDAY_GIFT"] = 36] = "BIRTHDAY_GIFT";
    PendingInventoryType[PendingInventoryType["TRADER_EVEENT_FULFILLED"] = 37] = "TRADER_EVEENT_FULFILLED";
    PendingInventoryType[PendingInventoryType["ANNIVERSARY_GIFT"] = 38] = "ANNIVERSARY_GIFT";
    PendingInventoryType[PendingInventoryType["CUSTOMER_POINTS_1"] = 41] = "CUSTOMER_POINTS_1";
    PendingInventoryType[PendingInventoryType["CUSTOMER_POINTS_2"] = 42] = "CUSTOMER_POINTS_2";
    PendingInventoryType[PendingInventoryType["CUSTOMER_POINTS_3"] = 43] = "CUSTOMER_POINTS_3";
    PendingInventoryType[PendingInventoryType["CUSTOMER_POINTS_4"] = 44] = "CUSTOMER_POINTS_4";
    PendingInventoryType[PendingInventoryType["CUSTOMER_POINTS_5"] = 45] = "CUSTOMER_POINTS_5";
    PendingInventoryType[PendingInventoryType["CUSTOMER_POINTS_6"] = 46] = "CUSTOMER_POINTS_6";
    PendingInventoryType[PendingInventoryType["COLLECT_LEAGUE_RANKING"] = 50] = "COLLECT_LEAGUE_RANKING";
    PendingInventoryType[PendingInventoryType["COLLECT_LEAGUE_POINTS_1"] = 51] = "COLLECT_LEAGUE_POINTS_1";
    PendingInventoryType[PendingInventoryType["COLLECT_LEAGUE_POINTS_2"] = 52] = "COLLECT_LEAGUE_POINTS_2";
    PendingInventoryType[PendingInventoryType["COLLECT_LEAGUE_POINTS_3"] = 53] = "COLLECT_LEAGUE_POINTS_3";
    PendingInventoryType[PendingInventoryType["COLLECT_LEAGUE_POINTS_4"] = 54] = "COLLECT_LEAGUE_POINTS_4";
    PendingInventoryType[PendingInventoryType["COLLECT_LEAGUE_POINTS_5"] = 55] = "COLLECT_LEAGUE_POINTS_5";
    PendingInventoryType[PendingInventoryType["COLLECT_LEAGUE_POINTS_6"] = 56] = "COLLECT_LEAGUE_POINTS_6";
    PendingInventoryType[PendingInventoryType["PURCHASE_POINT_EVENT_POINTS_1"] = 61] = "PURCHASE_POINT_EVENT_POINTS_1";
    PendingInventoryType[PendingInventoryType["PURCHASE_POINT_EVENT_POINTS_2"] = 62] = "PURCHASE_POINT_EVENT_POINTS_2";
    PendingInventoryType[PendingInventoryType["PURCHASE_POINT_EVENT_POINTS_3"] = 63] = "PURCHASE_POINT_EVENT_POINTS_3";
    PendingInventoryType[PendingInventoryType["PURCHASE_POINT_EVENT_POINTS_4"] = 64] = "PURCHASE_POINT_EVENT_POINTS_4";
    PendingInventoryType[PendingInventoryType["PURCHASE_POINT_EVENT_POINTS_5"] = 65] = "PURCHASE_POINT_EVENT_POINTS_5";
    PendingInventoryType[PendingInventoryType["PURCHASE_POINT_EVENT_POINTS_6"] = 66] = "PURCHASE_POINT_EVENT_POINTS_6";
    PendingInventoryType[PendingInventoryType["LONG_TERM_POINT_EVENT_RANKING"] = 70] = "LONG_TERM_POINT_EVENT_RANKING";
    PendingInventoryType[PendingInventoryType["LONG_TERM_POINT_EVENT_POINTS_1"] = 71] = "LONG_TERM_POINT_EVENT_POINTS_1";
    PendingInventoryType[PendingInventoryType["LONG_TERM_POINT_EVENT_POINTS_2"] = 72] = "LONG_TERM_POINT_EVENT_POINTS_2";
    PendingInventoryType[PendingInventoryType["LONG_TERM_POINT_EVENT_POINTS_3"] = 73] = "LONG_TERM_POINT_EVENT_POINTS_3";
    PendingInventoryType[PendingInventoryType["LONG_TERM_POINT_EVENT_POINTS_4"] = 74] = "LONG_TERM_POINT_EVENT_POINTS_4";
    PendingInventoryType[PendingInventoryType["LONG_TERM_POINT_EVENT_POINTS_5"] = 75] = "LONG_TERM_POINT_EVENT_POINTS_5";
    PendingInventoryType[PendingInventoryType["LONG_TERM_POINT_EVENT_POINTS_6"] = 76] = "LONG_TERM_POINT_EVENT_POINTS_6";
    PendingInventoryType[PendingInventoryType["PVP_EVENT_RANKING"] = 80] = "PVP_EVENT_RANKING";
    PendingInventoryType[PendingInventoryType["PVP_EVENT_POINTS_1"] = 81] = "PVP_EVENT_POINTS_1";
    PendingInventoryType[PendingInventoryType["PVP_EVENT_POINTS_2"] = 82] = "PVP_EVENT_POINTS_2";
    PendingInventoryType[PendingInventoryType["PVP_EVENT_POINTS_3"] = 83] = "PVP_EVENT_POINTS_3";
    PendingInventoryType[PendingInventoryType["PVP_EVENT_POINTS_4"] = 84] = "PVP_EVENT_POINTS_4";
    PendingInventoryType[PendingInventoryType["PVP_EVENT_POINTS_5"] = 85] = "PVP_EVENT_POINTS_5";
    PendingInventoryType[PendingInventoryType["PVP_EVENT_POINTS_6"] = 86] = "PVP_EVENT_POINTS_6";
})(PendingInventoryType || (PendingInventoryType = {}));
export var RewardSource;
(function (RewardSource) {
    RewardSource[RewardSource["Undefined"] = 0] = "Undefined";
    RewardSource[RewardSource["PURCHASE_OFFER"] = 1] = "PURCHASE_OFFER";
    RewardSource[RewardSource["PACKAGE"] = 2] = "PACKAGE";
    RewardSource[RewardSource["MISSING_RESOURCES"] = 3] = "MISSING_RESOURCES";
    RewardSource[RewardSource["HYDRA"] = 4] = "HYDRA";
    RewardSource[RewardSource["BALLOON"] = 5] = "BALLOON";
    RewardSource[RewardSource["BONUS"] = 6] = "BONUS";
    RewardSource[RewardSource["POINT_REWARD"] = 7] = "POINT_REWARD";
})(RewardSource || (RewardSource = {}));
export var AchievementContext;
(function (AchievementContext) {
    AchievementContext[AchievementContext["UNKNOWN"] = 0] = "UNKNOWN";
    AchievementContext[AchievementContext["FISH_CATCH"] = 1] = "FISH_CATCH";
})(AchievementContext || (AchievementContext = {}));
export var CoopMessageType;
(function (CoopMessageType) {
    CoopMessageType[CoopMessageType["COOP_UNDEFINED"] = 0] = "COOP_UNDEFINED";
    CoopMessageType[CoopMessageType["COOP_PROJECT_STARTED"] = 1] = "COOP_PROJECT_STARTED";
    CoopMessageType[CoopMessageType["COOP_PROJECT_COMPLETED"] = 2] = "COOP_PROJECT_COMPLETED";
    CoopMessageType[CoopMessageType["COOP_PROJECT_STOPPED"] = 3] = "COOP_PROJECT_STOPPED";
    CoopMessageType[CoopMessageType["COOP_PROJECT_FAILED"] = 4] = "COOP_PROJECT_FAILED";
    CoopMessageType[CoopMessageType["COOP_LEVELED_UP"] = 5] = "COOP_LEVELED_UP";
    CoopMessageType[CoopMessageType["COOP_PLAYER_JOINED"] = 6] = "COOP_PLAYER_JOINED";
    CoopMessageType[CoopMessageType["COOP_INVITED_PLAYER_JOINED"] = 7] = "COOP_INVITED_PLAYER_JOINED";
    CoopMessageType[CoopMessageType["COOP_PLAYER_LEFT"] = 8] = "COOP_PLAYER_LEFT";
    CoopMessageType[CoopMessageType["COOP_PLAYER_KICKED"] = 9] = "COOP_PLAYER_KICKED";
    CoopMessageType[CoopMessageType["COOP_PLAYER_RANK_CHANGED"] = 10] = "COOP_PLAYER_RANK_CHANGED";
    CoopMessageType[CoopMessageType["COOP_PLAYER_LEADERSHIP"] = 11] = "COOP_PLAYER_LEADERSHIP";
    CoopMessageType[CoopMessageType["COOP_PLAYER_DONATED"] = 12] = "COOP_PLAYER_DONATED";
    CoopMessageType[CoopMessageType["COOP_IMPROVEMENT_UPGRADE"] = 13] = "COOP_IMPROVEMENT_UPGRADE";
    CoopMessageType[CoopMessageType["COOP_BUFF_ACTIVATED"] = 14] = "COOP_BUFF_ACTIVATED";
})(CoopMessageType || (CoopMessageType = {}));
export var PlayerPreferencesPlatformType;
(function (PlayerPreferencesPlatformType) {
    PlayerPreferencesPlatformType[PlayerPreferencesPlatformType["PLAT_UNKNOWN"] = 0] = "PLAT_UNKNOWN";
    PlayerPreferencesPlatformType[PlayerPreferencesPlatformType["PLAT_SHARED"] = 1] = "PLAT_SHARED";
    PlayerPreferencesPlatformType[PlayerPreferencesPlatformType["PLAT_WEB"] = 2] = "PLAT_WEB";
    PlayerPreferencesPlatformType[PlayerPreferencesPlatformType["PLAT_MOBILE"] = 3] = "PLAT_MOBILE";
})(PlayerPreferencesPlatformType || (PlayerPreferencesPlatformType = {}));
export var Shop;
(function (Shop) {
    Shop[Shop["GOOGLEPLAY"] = 0] = "GOOGLEPLAY";
    Shop[Shop["APPSTORE"] = 1] = "APPSTORE";
    Shop[Shop["SUPPORT"] = 1000] = "SUPPORT";
})(Shop || (Shop = {}));
export var SubscriptionUpdateEvent;
(function (SubscriptionUpdateEvent) {
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_RECOVERED"] = 0] = "SUBSCRIPTION_RECOVERED";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_RENEWED"] = 1] = "SUBSCRIPTION_RENEWED";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_CANCELED"] = 2] = "SUBSCRIPTION_CANCELED";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_PURCHASED"] = 3] = "SUBSCRIPTION_PURCHASED";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_ON_HOLD"] = 4] = "SUBSCRIPTION_ON_HOLD";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_IN_GRACE_PERIOD"] = 5] = "SUBSCRIPTION_IN_GRACE_PERIOD";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_RESTARTED"] = 6] = "SUBSCRIPTION_RESTARTED";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_PRICE_CHANGE_CONFIRMED"] = 7] = "SUBSCRIPTION_PRICE_CHANGE_CONFIRMED";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_DEFERRED"] = 8] = "SUBSCRIPTION_DEFERRED";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_REVOKED"] = 9] = "SUBSCRIPTION_REVOKED";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_EXPIRED"] = 10] = "SUBSCRIPTION_EXPIRED";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_IOS_INITIAL_BUY"] = 11] = "SUBSCRIPTION_IOS_INITIAL_BUY";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_IOS_RENEWED"] = 12] = "SUBSCRIPTION_IOS_RENEWED";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_IOS_STOP"] = 13] = "SUBSCRIPTION_IOS_STOP";
    SubscriptionUpdateEvent[SubscriptionUpdateEvent["SUBSCRIPTION_IOS_CANCEL"] = 14] = "SUBSCRIPTION_IOS_CANCEL";
})(SubscriptionUpdateEvent || (SubscriptionUpdateEvent = {}));
export var PointRewardType;
(function (PointRewardType) {
    PointRewardType[PointRewardType["NORMAL"] = 0] = "NORMAL";
    PointRewardType[PointRewardType["SEASON_PASS"] = 1] = "SEASON_PASS";
})(PointRewardType || (PointRewardType = {}));
export var UnlockedPackageType;
(function (UnlockedPackageType) {
    UnlockedPackageType[UnlockedPackageType["LOGIN_BONUS"] = 0] = "LOGIN_BONUS";
    UnlockedPackageType[UnlockedPackageType["SUBSCRIPTION"] = 1] = "SUBSCRIPTION";
})(UnlockedPackageType || (UnlockedPackageType = {}));
export var MessageType;
(function (MessageType) {
    MessageType[MessageType["USER"] = 0] = "USER";
    MessageType[MessageType["SYSTEM"] = 1] = "SYSTEM";
    MessageType[MessageType["GAMEMASTER"] = 2] = "GAMEMASTER";
})(MessageType || (MessageType = {}));
export var ChatRoomType;
(function (ChatRoomType) {
    ChatRoomType[ChatRoomType["COOP"] = 0] = "COOP";
    ChatRoomType[ChatRoomType["COOP_LEADER"] = 1] = "COOP_LEADER";
    ChatRoomType[ChatRoomType["GLOBAL"] = 2] = "GLOBAL";
    ChatRoomType[ChatRoomType["PLAYER_TO_PLAYER"] = 3] = "PLAYER_TO_PLAYER";
})(ChatRoomType || (ChatRoomType = {}));
export var InboxItemType;
(function (InboxItemType) {
    InboxItemType[InboxItemType["SYSTEM"] = 0] = "SYSTEM";
    InboxItemType[InboxItemType["GAME_MASTER"] = 1] = "GAME_MASTER";
    InboxItemType[InboxItemType["VOUCHER"] = 2] = "VOUCHER";
})(InboxItemType || (InboxItemType = {}));
export var InboxItemAttachmentStatus;
(function (InboxItemAttachmentStatus) {
    InboxItemAttachmentStatus[InboxItemAttachmentStatus["CONTAINS_ATTACHMENTS"] = 0] = "CONTAINS_ATTACHMENTS";
    InboxItemAttachmentStatus[InboxItemAttachmentStatus["COLLECTED_ATTACHMENTS"] = 1] = "COLLECTED_ATTACHMENTS";
    InboxItemAttachmentStatus[InboxItemAttachmentStatus["NO_ATTACHMENTS"] = 2] = "NO_ATTACHMENTS";
})(InboxItemAttachmentStatus || (InboxItemAttachmentStatus = {}));



//////////////////
// WEBPACK FOOTER
// ./src/utils/network/generated/protoTypes.ts
// module id = 13
// module chunks = 3